import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { type PropsWithChildren, type RefObject } from "react";

interface ModalProps extends PropsWithChildren {
  title?: string;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  initialFocusRef?: RefObject<HTMLElement>;
}

const Modal = ({
  title,
  children,
  isOpen,
  setIsOpen,
  initialFocusRef,
}: ModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => { setIsOpen(false); }}
      initialFocus={initialFocusRef}
      transition
      className="fixed inset-0 z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />

      <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 sm:items-center">
          <DialogPanel
            transition
            className="relative w-full sm:max-w-lg rounded-2xl bg-base/90 backdrop-blur-2xl border border-border shadow-2xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:data-closed:translate-y-0 sm:data-closed:scale-95"
          >
            <div className="flex items-start justify-between gap-4 px-4 pt-4 sm:px-6 sm:pt-6">
              {title ? (
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-primary"
                >
                  {title}
                </DialogTitle>
              ) : (
                <span />
              )}

              <button
                type="button"
                onClick={() => { setIsOpen(false); }}
                className="inline-flex items-center justify-center rounded-md p-1 text-secondary hover:text-primary hover:bg-surface focus:outline-none focus:ring-2 focus:ring-border"
                aria-label="Zamknij"
              >
                <XMarkIcon className="size-5" />
              </button>
            </div>

            <div className="px-4 pb-4 pt-3 sm:px-6 sm:pb-6">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;
